import script from "./PartnerProjectFormStep10.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectFormStep10.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectFormStep10.vue?vue&type=style&index=0&id=c08ef5e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c08ef5e2"]])

export default __exports__